<template>
    <div id="pos">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'
import {initPos} from 'utils/initPageData'


export default { 
    name: 'Pos',
    components: {
        Screen
    },
    data() {
        return {
            showData: [],
            index: [],
            page1: [
            [ ['POS INIT',['','','']],
                [1,3]
            ], 
            [
                [ '', 'LAST POS' ], 
                [ '', '' ]
            ], 
            [ 
                [ 'REF AIRPORT', '' ], 
                [ '- - - -', '' ] 
            ],
            [ 
                [ 'GATE', '' ], 
                [ '- - - -', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ 'G M T - M O N / D Y', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '−−−−−−−−−−−−−−−−−−−−', '−−−−−−−−−−−−−−−−−−−−' ], 
                [ '<INDEX', 'ROUTE>' ] 
            ],
        ],
        page2:  [
            [ ['POS INIT',['','','']],
                [2,3]
            ],  
            [
                [ '\xa0\xa0\xa0 FMC \xa0 POS', 'G S' ], 
                [ '', '' ] 
            ], 
            [ 
                [ '\xa0\xa0\xa0 IRS \xa0 L', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '\xa0\xa0\xa0 IRS \xa0 R', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '\xa0\xa0\xa0 GPS \xa0 L', '' ], 
                [ 'N36°85.0 E117°22.2', '' ] 
            ],
            [ 
                [ '\xa0\xa0\xa0 GPS \xa0 R', '' ], 
                [ 'N36°85.3 E117°18.7', '' ] 
            ],
            [ 
                [ '\xa0\xa0\xa0 RADIO', '' ], 
                [ '', '' ] 
            ],
        ],
        page3:  [
            [
                ['POS SHIFT',['','','']],
                [3,3]
            ], 
            [
                [ '\xa0\xa0\xa0 FMC - L', 'FMC - R \xa0\xa0\xa0' ], 
                [ '<274°/0.0NM', '094°/0.3NM>' ] 
            ], 
            [ 
                [ '\xa0\xa0\xa0 GPS \xa0 L', ' GPS - R \xa0\xa0\xa0' ], 
                [ '<210°/1.4NM', '220°/1.3NM>' ] 
            ],
            [ 
                [ '\xa0\xa0\xa0 IRS - L', ' IRS - R \xa0\xa0\xa0' ], 
                [ '<300°/11NM', '110°/2.3NM>' ] 
            ],
            [ 
                [ '\xa0\xa0\xa0 RNP / ACTUAL', ' RADIO \xa0\xa0\xa0' ], 
                [ '\xa02.80 / 0.15NM', '084°/0.1NM>' ] 
            ],
            [ 
                [ '−−−−−− U P D A T E\xa0', 'C O M P L E T E −−−−−−' ], 
                [ '', 'NAV STATUS>' ] 
            ],
            [ 
                [ '', '' ], 
                [ '<INDEX', 'CANCEL>' ] 
            ],
        ],
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        },
        chgPage(){
            this.showData = this['page'+ this.index[0]]
        },
        initDada(){

            //获取当前的GMT时间
            let timestap = Date.parse(new Date())
            let month = new Date().getUTCMonth()
          console.log(month)
            let day = new Date().getUTCDate()

            // 设置GMT时间
            setInterval(() => {
                let hours = new Date().getUTCHours()
                let minutes = new Date().getUTCMinutes()
                let seconds = new Date().getUTCSeconds().toString()
                if(seconds.length === 1 ){
                    seconds = '0'
                }else{
                    seconds = seconds.slice(0,1)
                }
                this.page1[5][1].splice(0, 1, hours + '' + minutes + '.' + seconds + 'z'+ '\xa0' + (month + 1) + '\xa0/\xa0' + day)
            }, 1000);

            let adiruStatus = this.$store.state.fmcInputs.positionAndAirData.adiru.status
            let lastPos = this.$store.state.fmcInputs.positionAndAirData.adiru.lastPos
            let gpsPos2 = this.$store.state.fmcInputs.positionAndAirData.gps.pos1
            let gpsPos1 = this.$store.state.fmcInputs.positionAndAirData.gps.pos2
           
            this.page1[1][1].splice(1, 1, lastPos)

            if (adiruStatus===1||adiruStatus===2){
                //SER IRS POS
                this.page1[4][0].splice(1, 1, 'SET IRS POS')
                this.page1[4][1].splice(1, 1, '□□□°□□.□ □□□□°□□.□')

                //判断有没有输入第一页的位置信息
                if(this.$store.state.fmcInputs.positionAndAirData.adiru.pos1){
                    //判断输入的位置信息正确性
                    if(1){
                        //FMC POS
                        this.page2[1][1].splice(0, 1, lastPos)
                        this.page2[1][1].splice(1, 1, '1 KT')
                        
                        //IRS pos
                        this.page2[2][1].splice(0, 1, gpsPos2)
                        this.page2[2][1].splice(1, 1, '3 KT')
                        this.page2[3][1].splice(0, 1, gpsPos1)
                        this.page2[3][1].splice(1, 1, '2 KT')

                        //Radios POS
                        this.page2[6][1].splice(0, 1, gpsPos2)
                    }
                }

            }else if(adiruStatus==3){
                this.page1[5][0].splice(1, 1, 'SET IRS HDG')
                this.page1[5][1].splice(1, 1, '- - -°')
            }

        }
    },
    created() {
        this.initDada()
        this.initPage()
        if(this.$route.query.index){
            this.index.splice(0,1,this.$route.query.index)
            this.chgPage()
        }
        initPos(this)
    },
    watch: {
        'index': {
            handler(newV,oldV){
                initPos(this)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>